import { Grid, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  saveActividadesAcademicasAction,
  setActivoActividadesAcademicasAction,
} from '../ActividadesAcademicasAction';

const FormActividadesAcademicas = ({ isDelete = false }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const actividadesAcademicasStore = Redux.useSelector(
    (state) => state.actividadesAcademicas,
  );

  const activo = isDelete ? null : actividadesAcademicasStore.activo;

  const initData = {
    nombre: '',
    desc: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    desc: '',
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveActividadesAcademicasAction(
        { dispatch, notify },
        activo?.id,
        data,
        actividadesAcademicasStore.params,
      );
      // if (res) setOpenModalForm(false);
      if (res) clearData();
      setLoadingSave(false);
    }
  };

  function clearData() {
    setActivoActividadesAcademicasAction(dispatch, null);
    setData(initData);
  }

  return (
    <Box component="form" sx={{ m: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          <Typography variant="h6">
            {activo ? 'Editar actividad' : 'Crear'}
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(
                CONST.nombre.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            required
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text="GUARDAR"
            disabled={loadingSave}
            green
            mr={2}
          />
          {activo && (
            <BotonComponent
              click={clearData}
              text="CANCELAR"
              disabled={loadingSave}
              black
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormActividadesAcademicas;
